module.exports = __webpack_public_path__ + "img/img-4.94951389.png";